
export class PosTabs {
	constructor(node) {
		// tabs
		this.posTabs = node.querySelectorAll('[data-pos-tab-btn]')
		this.posTabsContent = node.querySelectorAll('[data-pos-tab-content]')
		this.posTabsLine = node.querySelector('[data-pos-tab-line]')

		this.posVwCityBoxes = node.querySelectorAll('[data-pos-vwcity]')
		this.posVwCityBackBtn = node.querySelector('[data-pos-vwcity-back]')
		this.posVwBtns = this.posVwCityBoxes[0].querySelectorAll('[data-pos-vw]')
		this.currentVoivodeship = null

		this.setTabsEvents()
	}

	setTabsEvents() {

		// tabs btns
		for (let i = 0; i < this.posTabs.length; i++) {
			const btn = this.posTabs[i]
			btn.setAttribute('data-pos-key', i)
			btn.addEventListener('click', () => {
				const key = btn.getAttribute('data-pos-key')
				if (key === '1') {
					this.posTabsLine.classList.add('pos__tabs__line--pos2')
					this.posTabsContent[0].classList.remove('active')
					this.posTabsContent[1].classList.add('active')
				} else {
					this.posTabsLine.classList.remove('pos__tabs__line--pos2')
					this.posTabsContent[0].classList.add('active')
					this.posTabsContent[1].classList.remove('active')
				}
			})
		}

		// voiwodes
		for (let i = 0; i < this.posVwBtns.length; i++) {
			const vw = this.posVwBtns[i]
			vw.addEventListener('click', () => {
				const vwName = vw.getAttribute('data-pos-vw')
				this.posVwCityBoxes[0].classList.add('hide')
				this.currentVoivodeship = this.posVwCityBoxes[1].querySelector(`[data-pos-vw="${vwName}"]`)
				this.currentVoivodeship.classList.remove('hide')
				this.posVwCityBoxes[1].classList.remove('hide')
			})
		}


		this.posVwCityBackBtn.addEventListener('click', () => {
			this.posVwCityBoxes[0].classList.remove('hide');
			const that = this;
			setTimeout(function () { that.posVwCityBoxes[0].focus(); }, 100);
			this.posVwCityBoxes[1].classList.add('hide');
			if (this.currentVoivodeship) this.currentVoivodeship.classList.add('hide');
		})
	}

}